<template>
    <div class="all">
        <div class="warp">
            <div class="warp-body">
                <div class="firle clearfix">
                    <h2 class="fl">我的下载</h2>
                    <div class="fr">
                        <button class="btn btn-jbblue" @click="delDownload();">批量删除</button>
                    </div>
                </div>
                <table v-if="list != ''" class="table mt20" width="100%" border="0" cellpadding="0" cellspacing="0">
                    <colgroup>
                        <col width="80px">
                        <col width="30%">
                        <col width="15%">
                        <col width="20%">
                        <col width="20%">
                        <col width="10%">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>
                                <label class="checkbox-box tion">
                                    <label class="checkbox-warp fl">
                                        <input class="checkbox" name="selectAll" :checked="recordIds.length === pageUuid.length" @change="checkAll($event)" type="checkbox" value="0">
                                        <i class="icons checkbox-icon"></i>
                                    </label>
                                    全选
                                </label>
                            </th>
                            <th>标题</th>
                            <th>数据量</th>
                            <th>生成时间</th>
                            <th>下载进度</th>
                            <th>操作</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in list" :key="index">
                            <td>
                                <label class="checkbox-warp">
                                    <input class="checkbox" v-model="recordIds" name="chooseInfo" type="checkbox" :value="item.recordId">
                                    <i class="icons checkbox-icon"></i>
                                </label>
                            </td>
                            <td><span class="ovhidden">{{item.title}}</span></td>
                            <td>{{item.dataNum}}</td>
                            <td>{{item.createTime}}</td>
                            <td>
								<div class="line dib w60" :class="{error:item.status === -1}">
									<div class="in" :style='{width:""+item.process+"%"}'>{{item.status === -1 ? '下载失败' : ''}}</div>
								</div>
								<span class="color-blue" v-if="item.status != -1">{{item.process}}%</span>
							</td>
							<td>
								<div class="table-all-icons" v-if="item.status === 2">
									<a class="icons download-icon" :href="item.url == '' ? 'javascript:void(0);' : item.url" title="下载"></a>
									<a class="icons del-icon" href="javascript:void(0);" title="删除" @click="delDownload(item.recordId);"></a>
								</div>
								<div class="table-all-icons" v-else>
									<button class="btn btn-error" v-if="item.status === 1 || item.status === 0" @click="cancelDownload(item.recordId,index)">取消下载</button>
									<button class="btn btn-error" v-if="item.status === -1" @click="reDownload(item.recordId,index)">重新下载</button>
								</div>
							</td>
                        </tr>
                    </tbody>
                </table>
                <div class="no-data" v-if="nodata"><span class="text">没有数据哦...</span></div>
                <!-- 分页 -->
                <page class="mt20" v-if="totalCount != ''" :currentPage.sync="page" :limit.sync="limit" :totalCount="totalCount"  @turn="getTableData"></page>
            </div>
        </div>
	</div>
</template>
<script>
import page from '../../components/page.vue';
import Dialog from '../../components/dialog.vue';
export default {
    components:{Dialog,page},
    data() {
        return {
            pageUuid:'',//单页面所有recordId
            list:[],//下载列表
            recordIds:[],//所选的单页面所有recordId
            page:1,
            timer:'',
		    limit:20,//每页显示条数
            notDownload:[],//未完成的下载数组
            totalCount:'',//总页数
            nodata:''
        }
    },
    mounted() {
		let that = this;
        that.$nextTick(()=> {
            that.getDownloadList();
        }) 
    },
    beforeDestroy() {
        clearInterval(this.timer);
    },
    created() {
        
    },
    methods: {
		// 获取下载列表
        getDownloadList (type) {
            let that = this;
            if(type === 0){
                that.page = 1;
            }
            // that.recordIds = [];
            // $(".warp .checkbox-warp").removeClass('curr');
            // $(".warp input:checkbox[name='selectAll']").prop("checked",false);
            that.$parent.loadModal(true,'正在获取数据...');
            that.$api.get('user/index/download-records',{page:that.page,perpage:that.limit},r =>{
                that.$parent.showLoad = false;
                that.$utils.returnCode(r,function(){
					that.list = r.data.list;
					that.limit = r.data.limit;
					if(r.data.list.length <= 0){//没有数据
						that.nodata = true;
						return;
					}else{
						that.nodata = false;
					} 
					let pageUuid = [];
					let notDownload = [];//未完成下载的
					for(let i of r.data.list){
						pageUuid.push(i.recordId);
						if(i.status === 0 || i.status === 1){
							notDownload.push(i.recordId);
						}
					}
					that.notDownload = notDownload;
					that.pageUuid = pageUuid;
					that.totalCount = r.data.total;
					if(notDownload.length != 0){
						that.timer = setInterval(() => {
							that.getDownloadState();  
						}, 1000);
					}
                })
            })
        },
        // 翻页
        getTableData () {
            let that = this;
            clearInterval(that.timer);
            that.getDownloadList();
        },
        // 全选状态
        checkAll (e) {
            let that = this;
            let checked = e.target.checked;
            if(checked == true){
                that.recordIds = that.pageUuid;//全选的时候 获取所有的uuid
            }else{
                that.recordIds = [];
            }
        },
        // 删除下载
        delDownload (id) {
            let that = this;
            let ids = '';
            if(id){//单独删除
                ids = [id];
            }else{//批量
                ids = that.recordIds;
                if(ids.length <= 0){
                    that.$utils.alertText('请选择要删除得任务');
                    return;
                }
            }
            that.$confirm('是否删除所选下载任务？').then(() => {
				let datas = {
                    recordIds:ids
                }
                that.$parent.loadModal(true,'正在删除...');
                that.$api.post('user/index/delete-download-record',{data:datas},r =>{
                    that.$utils.returnCode(r,function(){
                        that.$parent.showLoad = false;
                        that.getDownloadList(0);
                        that.$utils.alertText('删除成功');
                    })
                })
			})
        },
		// 重新下载
		reDownload (id,index){
			let that = this;
			let data = {
				recordId:id
			}
			that.$api.post('user/index/re-download',{data:data},r =>{
				that.$utils.returnCode(r,function(){
					// that.list.splice(index,1);
					that.list[index].process = 0;
					that.list[index].status = 0;
					that.notDownload.push(id);
					that.timer = setInterval(() => {
						that.getDownloadState();  
					}, 1000);
				})
			})
		},
		// 取消下载
		cancelDownload (id,index){
			let that = this;
			that.$confirm('是否取消下载？').then(() => {
				let data = {
					recordId:id
				}
				that.$api.post('user/index/cancel-download',{data:data},r =>{
					that.$utils.returnCode(r,function(){
						that.list.splice(index,1);
						that.notDownload.splice(index,1);
					})
				})
			})
		},
        // 获取下载状态
        getDownloadState () {
            let that = this;
            let notDownload = that.notDownload;
            if(notDownload.length === 0){
                clearInterval(that.timer);
                return;
            }
            that.$api.get('user/index/check-download-status',{recordId:notDownload},r =>{
                that.$utils.returnCode(r,function(){
                    let data = r.data;
					for(let i of data){
						if(i.status === 2 || i.status === -1){
							let index = notDownload.indexOf(i.recordId);
							notDownload.splice(index,1);
						}
						for(let j of that.list){
							if(i.recordId === j.recordId){
								j.process = i.process;
								j.url = i.url;
								j.status = i.status;
							}
						}
					}
                })
            })
        }
	}
}
</script>



// WEBPACK FOOTER //
// src/page/personalCenter/myDownload.vue